export const AVATAR_COLOR_STYLES = [
  'turquoise',
  'green',
  'yellow',
  'orange',
  'red',
  'mauve',
  'purple',
  'bleu',
].map((color) => ({
  backgroundColor: `var(--tag-${color}-background)`,
  color: `var(--tag-${color}-color)`,
}))

export const getColorStyleForLabel = (label: string | null) => {
  if (!label) {
    return {
      backgroundColor: '#f5f5f7',
      color: '#72727D',
    }
  }
  const num = label
    .split('')
    .map((c) => c.charCodeAt(0))
    .join('')

  const modulo = parseInt(num, 10) % Object.keys(AVATAR_COLOR_STYLES).length
  return AVATAR_COLOR_STYLES[modulo]
}

export type AvatarSize =
  | 'xxsmall'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'huge'

export const AVATAR_SIZE_MAP: Record<AvatarSize, number> = {
  xxsmall: 18,
  xsmall: 20,
  small: 24,
  medium: 32,
  large: 40,
  huge: 50,
}

export const AVATAR_BORDER_WIDTH_MAP: Record<AvatarSize, number> = {
  xxsmall: 1,
  xsmall: 1,
  small: 1,
  medium: 1,
  large: 1,
  huge: 2,
}
